export default __webpack_public_path__ + "images/62_1_image.jpg";